import '../style/Services.css';
import { motion } from 'framer-motion';

const services = [
  {
    title: 'AIR FREIGHT',
    description:
      'We offer fast and secure air cargo transportation for urgent, high-value, or temperature-sensitive shipments. Partnering with major airlines, we provide efficient booking, customs clearance, and last-mile delivery to global destinations.\n\nOur solutions are tailored for flexibility, cost-effectiveness, and minimal delays. With real-time tracking and dedicated support, we ensure your cargo arrives safely and on time.',
    image: 'one.jpeg',
  },
  {
    title: 'SEA FREIGHT',
    description:
      'Our sea freight services provide cost-effective shipping for full container loads(FCL) and less-than-container loads(LCL). We work with leading carriers to offer competitive rates, reliable schedules and smooth cargo handling.\n\nOut team manages everything from documentation to port clearance, ensuring efficient transit. Whether bulk commodities or specialized shipments, we guarantee secure and timely delivery.',
    image: 'two.jpeg',
  },
  {
    title: 'LAND TRANSAPORTATION',
    description:
      'We provide reliable road transport services across Tanzania and beyond, ensuring safe and timely deliveries. Our well-maintained fleet handles general cargo, heavy equipment, and perishables with tailored solutions.\n\nClients can choose between full truckload(FTL) or less-than-truckload(LTL) options based on their needs. With GPS tracking and route optimization, we guarantee efficiency and security.',
    image: 'three.jpeg',
  },
  {
    title: 'CUSTOMS BROKERAGE',
    description:
      'Navigating customs procedures can be complex, but our experienced team ensures smooth clearance for imports. We handle documentation, duties, taxes and authorities expedite processing, saving time and costs.\n\nWhether standard or specialized shipments, we streamline the process for hassle-free global trade.',
    image: 'four.jpeg',
  },
  {
    title: 'EXEMPTION CONSULTANCY',
    description:
      'We help business take advantage of duty and tax exemptions to reduce import and export costs. Our experts identify eligible exemptions, handle paperwork, and provide strategic advice for cost-saving opportunities.\n\nOur consultancy service simplifies international trade while maximizing financial benefits.',
    image: 'saba.jpeg',
  },
  {
    title: 'PROJECT CARGO',
    description:
      'Handling oversized, heavy, or complex shipments requires specialized expertise, and we deliver just that. Our project cargo solutions cater to industries like construction, energy and infrastructure, ensuring safe transport.\n\nFrom route planning to risk assessments, we manage logistics with precision. With customized solutions and global partnerships, we guarantee smooth, timely deliveries.',
    image: 'tatu.jpeg',
  },
  {
    title: 'WAREHOUSING',
    description:
      'Our secure and modern warehousing facilities offer short-term and long-term storage solutions. Businesses benefit from advanced inventory management, climate-controlled storage, and efficient order fulfillment.\n\nOur real-time tracking system ensures stock visibility and minimizes supply chain disruptions. Whether bulk goods or sensitive products, we provide safe and organized storage.',
    image: 'kumi.jpeg',
  },
  {
    title: 'PET RELOCATION',
    description:
      'Moving pets can be challenging, but our pet relocation services ensures a smooth and stress-free process. We handle all necessary documentation, permits, flight bookings, and well-being of pets by providing secure transport containers, veterinary health checks, and careful handling.\n\nWhether relocating locally or internationally, we ensure you furry companion arrives safely and in perfect health.',
    image: 'tano.jpeg',
  },
  {
    title: 'HOUSEHOLD REMOVAL AND RELOCATION',
    description:
      'Relocating your home is seamless with our comprehensive household removal and relocation services. We manage the entire process, including packing, loading, transportation, unloading, and unpacking, ensuring your belongings are handled with care.\n\nWhether moving locally or internationally, we provide customized solutions for fragile items, furniture, and valuables. With reliable logistics and dedicated support, we make your move efficient and stress-free.',
    image: 'nane.jpeg',
  },
  {
    title: 'AGRICULTURAL AND FARM PRODUCE',
    description:
      'We provide reliable and efficient logistics solutions for agricultural and farm produce, ensuring the safe transportation of perishable and non-perishable goods.\n\nWhether shipping fresh produce, grains, or livestock feed, we offer tailored solutions to meet the industrys unique demands. With real-time tracking and optimized supply chain management, we help farmers and agribusinesses reach local and international markets efficiently.',
    image: 'sita.jpeg',
  },
  {
    title: 'HEALTHCARE AND PHARMACEUTICAL',
    description:
      'Our specialized logistics services for the healthcare and pharmaceutical industry ensure the secure and timely transportation of medical supplies, equipment, and customized solutions to support critical healthcare supply chains.\n\nWith our expertise in handling sensitive shipments, we ensure uninterrupted acces to essential medical products.',
    image: 'nne.jpeg',
  },
];

export default function Services() {
  return (
    <section className="Services" id="services" aria-label="Services">
      <div className="Services-inner">
        <section className="ServicesProcess" aria-label="Our services">
          <div className="ServicesProcess-header">
            <h3 className="ServicesProcess-title">Our Services</h3>
            <p className="ServicesProcess-subtitle">
              Comprehensive logistics solutions designed for secure, efficient,
              and reliable cargo movement.
            </p>
          </div>

          <div className="ServicesProcess-stack">
            {services.map((item, idx) => {
              const paragraphs = item.description.split('\n\n').filter(Boolean);
              return (
              <div key={item.title} className="ServicesProcess-sticky">
                <motion.article
                  className={
                    idx % 2 === 1
                      ? 'ServicesProcess-card ServicesProcess-cardReverse'
                      : 'ServicesProcess-card'
                  }
                  initial={{ opacity: 0, y: 28 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{ duration: 0.5, ease: 'easeOut' }}
                >
                  <div className="ServicesProcess-copy">
                    <h4>{item.title}</h4>
                    {paragraphs.map((paragraph, pIdx) => (
                      <p key={pIdx}>{paragraph}</p>
                    ))}
                  </div>

                  <div className="ServicesProcess-media">
                    <img
                      src={`${process.env.PUBLIC_URL}/image/${item.image}`}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                </motion.article>
              </div>
            )})}
          </div>
        </section>
      </div>
    </section>
  );
}

